<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FnuOqf/tc-custom/9783989732988.jpg?1731055219889" alt="This image is the cover for the book The House On The Cliff, CLASSICS TO GO"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The House On The Cliff, CLASSICS TO GO
      </h1>
      <p class="bookDescription body article font2">
        <p>When Frank and Joe Hardy's father, the renowned detective Fenton Hardy, takes on a mysterious case involving smuggling and a perilous cliffside mansion, the Hardy boys find themselves thrust into an exhilarating adventure. As they navigate secret passages, cryptic clues, and shadowy figures, they must use their wits and courage to uncover the truth and bring justice to Bayport. "The House On The Cliff" is a thrilling testament to the power of determination and teamwork, resonating with contemporary themes of family loyalty, the quest for truth, and the fight against corruption. This classic tale continues to captivate readers, reminding us that bravery and ingenuity are timeless virtues.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Franklin W. Dixon
      </h2>
      
      <p class="authorDescription body article">Franklin W. Dixon is a pseudonym that has captivated generations of readers, primarily known for the creation of the Hardy Boys series. The name represents a collective of authors who contributed to the series, with the most notable being Leslie McFarlane. Born in 1902 in Carleton Place, Ontario, McFarlane's journey into the literary world began with his work as a journalist and screenwriter. <br>The Hardy Boys series, first published in 1927, became a cultural phenomenon, shaping the landscape of children's literature. The books, filled with mystery, adventure, and moral lessons, were revolutionary in their appeal to young readers, encouraging a love for reading and critical thinking. The series' success is often attributed to its formulaic yet engaging storytelling, which combined suspense with relatable characters.<br>Controversy surrounded the series due to its use of ghostwriters and the stringent guidelines imposed by the Stratemeyer Syndicate, the publishing company behind the pseudonym. Critics argued that this approach stifled individual creativity, yet it ensured a consistent and beloved product.<br>Franklin W. Dixon's influence extends beyond the Hardy Boys. The series inspired contemporary writers and laid the groundwork for modern young adult fiction. The themes of justice, bravery, and resourcefulness continue to resonate, proving that the legacy of Franklin W. Dixon is not just a relic of the past but a cornerstone of literary history that continues to inspire and entertain.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18e20a04